import React from "react";
import { Box, Dialog, Divider, Typography, useTheme } from "@mui/material";
import { WizardResetConfirm } from "../types";
import { ButtonPrimary } from "src/UI/ButtonPrimary";
import { ButtonSecondary } from "src/UI/ButtonSecondary";

interface WizardResetDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  copy: WizardResetConfirm;
}

const WizardResetDialog: React.FC<WizardResetDialogProps> = ({
  open,
  onClose,
  onConfirm,
  copy,
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={false}
      PaperProps={{
        sx: {
          maxWidth: "600px",
          backgroundColor: theme.palette.background.default,
          borderRadius: "16px",
          border: `1px solid ${theme.palette.divider}`,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          gap: "16px",
          padding: "32px",
          color: theme.palette.text.primary,
        }}
      >
        <Typography
          sx={{
            fontSize: "24px",
            fontWeight: 700,
            lineHeight: 1.2,
            color: theme.palette.text.primary,
            overflowWrap: "anywhere",
          }}
        >
          {copy.title}
        </Typography>
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 400,
            lineHeight: 1.5,
            color: theme.palette.text.primary,
          }}
        >
          {copy.description}
        </Typography>
        <Divider flexItem />
        <Box sx={{ display: "flex", gap: 1.5, width: "100%" }}>
          <ButtonSecondary size="md" onClick={onClose} sx={{ flex: 1 }}>
            {copy.cancelLabel}
          </ButtonSecondary>
          <ButtonPrimary size="md" onClick={onConfirm} sx={{ flex: 1 }}>
            {copy.confirmLabel}
          </ButtonPrimary>
        </Box>
      </Box>
    </Dialog>
  );
};

export default WizardResetDialog;
